@if (contactSales(); as contact) {
<div class="paywall-contact">
  <div class="paywall-contact__card">
    <div class="paywall-contact__top">
      <button type="button" class="paywall-contact__back" (click)="goBack()">Back</button>
      <h2>{{ contact.title }}</h2>
      <p class="paywall-contact__description">
        {{ contact.subTitle }}
      </p>
      <p class="paywall-contact__sla">{{ contact.slaNote }}</p>
    </div>
    <div class="paywall-contact__bottom">
      <h3>{{ contact.includesTitle }}</h3>
      <div [innerHTML]="contact.includesHtml"></div>

      <form [formGroup]="contactForm()" (ngSubmit)="submit()" novalidate>
        @for (field of fields(); track field.key) {
          <label [for]="controlId(field)">
            {{ field.label }}
            @if (field.required) { <span class="paywall-contact__required" aria-hidden="true">*</span> }
          </label>
          @if (field.key === 'note') {
            <textarea
              [id]="controlId(field)"
              [formControlName]="field.key"
              rows="4"
              [required]="field.required"
              [attr.aria-invalid]="!!fieldError(field)"
              [attr.aria-describedby]="fieldError(field) ? controlId(field) + '-error' : null"></textarea>
          } @else {
            <input
              [id]="controlId(field)"
              [type]="inputType(field)"
              [formControlName]="field.key"
              [attr.autocomplete]="autocomplete(field)"
              [attr.min]="field.key === 'seats' ? 1 : null"
              [attr.inputmode]="field.key === 'seats' ? 'numeric' : field.key === 'phone' ? 'tel' : null"
              [required]="field.required"
              [attr.aria-invalid]="!!fieldError(field)"
              [attr.aria-describedby]="fieldError(field) ? controlId(field) + '-error' : null">
          }
          @if (fieldError(field); as error) {
            <p class="paywall-contact__field-error" [id]="controlId(field) + '-error'">{{ error }}</p>
          }
        }

        @if (submitError()) {
          <p class="paywall-contact__error">{{ submitError() }}</p>
        }

        @if (paywallService.isPreview()) {
          <p class="paywall-contact__error">Sending requests is disabled in preview.</p>
        }

        <button
          type="submit"
          class="paywall-contact__submit"
          [disabled]="submitting() || paywallService.isPreview()">
          Contact Sales
        </button>
      </form>
    </div>
  </div>
</div>
}
